module.exports = __webpack_public_path__ + "media/images/bg_min-33ad1ee4743e645fa1a6b6fbcdc9485e.png";